<nz-header>
    <div class="app-header">
        <!-- Logo for unauthenticated users -->
        <div *ngIf="!LoggedInUser" nz-row nzJustify="center" class="logo-container">
            <a target="_blank">
                <img class="logo" src="assets/logo.png" alt="logo">
            </a>
        </div>

        <!-- Authenticated user header -->
        <div *ngIf="LoggedInUser" nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="user-header">
            <!-- Sidebar toggle -->
            <div nz-col [nzSpan]="8" class="trigger-container">
                <span class="header-trigger" (click)="ToggleIt()">
                    <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
                </span>
            </div>

            <!-- Centered logo -->
            <div nz-col [nzSpan]="8" nz-row nzJustify="center" class="logo-container">
                <a [routerLink]="'/clients'">
                    <img class="logo" src="assets/logo.png" alt="logo">
                </a>
            </div>

            <!-- Admin menu -->
            <div nz-col [nzSpan]="8" class="admin-menu">
                <ul nz-menu [nzMode]="'horizontal'" class="menu custom-horizontal-menu">
                  <li nz-submenu>
                    <span title style="text-decoration: none;">
                      <i nz-icon nzType="user" nzTheme="outline"></i>
                      <span>Admin</span>
                    </span>
                    <ul>
                      <li nz-menu-item (click)="signOut()">Sign out</li>
                    </ul>
                  </li>
                </ul>
            </div>  
        </div>
    </div>
</nz-header>